// src/lib/supabase.js
import { createClient } from '@supabase/supabase-js'

const supabaseUrl = process.env.VUE_APP_SUPABASE_URL
const supabaseAnon = process.env.VUE_APP_SUPABASE_ANON_KEY

if (!supabaseUrl || !supabaseAnon) {
  // 在開發期幫你提早發現設定問題
  // eslint-disable-next-line no-console
  console.error('[Supabase] Missing env: VUE_APP_SUPABASE_URL or VUE_APP_SUPABASE_ANON_KEY')
}

export const supabase = createClient(supabaseUrl, supabaseAnon, {
  auth: {
    // 信箱驗證成功後的返回網址（可選）
    detectSessionInUrl: true,
    flowType: 'pkce',
    autoRefreshToken: true,
    persistSession: true,
  },
})
